export default "__VITE_ASSET__BQmobHD8__";